module.exports = __webpack_public_path__ + "img/53.2faa7e65.png";